import styles from "./VideoDetailsSection.module.css";
import FileUploadArea from "../../modals/ProposalCreateModal/FileUploadArea.jsx";
import { ReactComponent as DeleteIcon } from "../../assets/icons/VideoLibrary/DeleteIcon.svg";

/** Header button that removes this video row. The click handler is the parent's stable callback. */
export const RemoveVideoButton = ({ onRemove, label }) => (
  <div className={styles.videoSectionHeader}>
    <div className={styles.headerButtons}>
      <button type="button" className={styles.removeVideoButton} onClick={onRemove}>
        <DeleteIcon className={styles.deleteIcon} />
        {label}
      </button>
    </div>
  </div>
);

/** Single-line name or description field. The parent owns the change handler and the video object. */
export const VideoTextField = ({ label, placeholder, value, onChange }) => (
  <div className={styles.inputGroup}>
    <label className={styles.label}>{label}</label>
    <input
      type="text"
      className={styles.input}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  </div>
);

/**
 * Drop zone plus the hidden file input.
 * The input stays in the DOM so the drop zone can open it by id.
 */
export const VideoFileUpload = ({
  file,
  isDragging,
  onFileChange,
  onDragOver,
  onDragLeave,
  onDrop,
  onClick,
  fileInputId,
}) => (
  <div className={styles.fileUploadContainer}>
    <FileUploadArea
      file={file}
      isUploading={false}
      isDragging={isDragging}
      error={null}
      onFileChange={onFileChange}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      onClick={onClick}
    />
    <input
      id={fileInputId}
      type="file"
      accept="video/*"
      onChange={onFileChange}
      className={styles.fileInput}
      style={{ display: "none" }}
    />
  </div>
);

/**
 * Preview player, or the placeholder when no file or stored URL is selected.
 * loadedmetadata is forwarded so the hook can read duration and seek.
 */
export const VideoPreview = ({
  videoRef,
  videoPreview,
  onLoadedMetadata,
  placeholder,
}) => (
  <div className={styles.videoPreviewContainer}>
    {videoPreview ? (
      <video
        ref={videoRef}
        src={videoPreview}
        className={styles.videoPreview}
        controls
        preload="metadata"
        onLoadedMetadata={onLoadedMetadata}
      />
    ) : (
      <div className={styles.previewPlaceholder}>{placeholder}</div>
    )}
  </div>
);

/**
 * Thumbnail second input. An empty or undefined value displays as blank.
 * The max is the floored duration when metadata has loaded.
 */
export const VideoThumbnailField = ({
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  duration,
}) => {
  const displayValue = value !== undefined && value !== "" ? value : "";
  const max = duration !== null ? Math.floor(duration) : undefined;

  return (
    <div className={styles.thumbnailSecondContainer}>
      <label className={styles.label}>{label}</label>
      <input
        type="number"
        className={styles.input}
        placeholder={placeholder}
        value={displayValue}
        onChange={onChange}
        onBlur={onBlur}
        min="0"
        max={max}
      />
    </div>
  );
};
